<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <!--<div><el-button icon="el-icon-search" @click="exports()">导出表格</el-button></div>-->
                    <div><el-input v-model="where.yuym" placeholder="请输入预约码"></el-input></div>
                    <div><el-date-picker format="yyyy-MM-dd HH:mm" v-model="where.times" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker></div>
                    <div style="width:160px;">
                        <el-select v-model="where.dingdzt" placeholder="选择类型">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="待服务" value="1"></el-option>
                            <el-option label="已取消" value="2"></el-option>
                            <el-option label="已完成" value="3"></el-option>
                        </el-select>
                    </div>
                    <div><el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button></div>
                </div>

                <div class="admin_main_block_right">
                    <!--<div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>-->
                </div>
            </div>
            <div class="admin_table_main">
                <el-table :data="list" @selection-change="handleSelectionChange" >
                    <el-table-column type="selection"></el-table-column>
                    <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                    <el-table-column prop="id" label="#"  width="70px"></el-table-column>
                    <el-table-column prop="yonghxm" label="预约人微信昵称" width="105px"></el-table-column>
                    <el-table-column prop="shoujh" label="预约人手机号" width="100px"></el-table-column>
                    <el-table-column prop="yuym" label="预约码" width="80px"></el-table-column>
                    <el-table-column prop="mendmc" label="预约门店" width="110px"></el-table-column>
                    <el-table-column prop="huls" label="护理师" width="60px"></el-table-column>
                    <el-table-column prop="yuysj" label="预约时间" width="140px"></el-table-column>


                    <el-table-column label="订单状态" >
                        <template slot-scope="scope">
                            <el-tag type="danger" v-if="scope.row.dingdzt==1">待服务</el-tag>
                            <el-tag type="warning" v-else-if="scope.row.dingdzt==2">已取消</el-tag>
                            <el-tag type="success" v-else-if="scope.row.dingdzt==3">已完成</el-tag>
                        </template>
                    </el-table-column>


                    <el-table-column prop="adv_start" label="创建时间" width="120px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.chuangjsj<=0"> - </div>
                            <div v-else>{{scope.row.chuangjsj|formatDate}}</div>
                        </template>
                    </el-table-column>




                    <el-table-column label="操作" fixed="right" width="310px">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-bank-card" @click="change_user_money(scope.row.id)">核销</el-button>
                            <el-button icon="el-icon-edit" @click="$router.push('/Admin/paiqgl/info/'+scope.row.id)">查看评价</el-button>
                            <el-button type="el-icon-edit" icon="el-icon-delete" @click="paiqtz(scope.row.id)">排期调整</el-button>
                        </template>
                    </el-table-column>
                    <div>
                        <div class='sum_footer xiaoji' ref='sum_xiaoji'>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit center' >总金额：{{zongje}}</div>
                            <div class='sum_footer_unit center' >订单数：{{dingds}}</div>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit'></div>
                            <div class='sum_footer_unit'></div>
                        </div>
                    </div>
                </el-table>
                <div class="admin_table_main_pagination">
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                </div>
            </div>
        </div>




        <!-- 调整资金弹出框 -->
        <el-dialog title="请输入预约码" :visible.sync="changeShow" width="30%">
            <el-form ref="form"  label-width="90px">
                <!--<el-form-item label="快递方：">
                    <el-input v-model="change_info.kuaidf"></el-input>
                </el-form-item>-->
                <el-form-item label="预约码:">
                    <el-input v-model="change_info.yuym"></el-input>
                </el-form-item>
            </el-form>


            <span slot="footer" class="dialog-footer">
                <el-button @click="changeShow = false">取 消</el-button>
                <el-button type="primary" @click="change_start()">确 定</el-button>
            </span>
        </el-dialog>




        <el-drawer title="排期调整" :append-to-body="true" :before-close="handleClose" :visible.sync="innerDrawer">
            <div class="demo-drawer__content">
                <div class="content">
                    <el-form :model="addForm">
                        <el-form-item label="班次：" label-width="60px" style="margin-top:30px;">
                            <el-radio-group v-model="addForm.shij">
                                <el-radio label="1">08:00:00</el-radio>
                                <el-radio label="2">08:45:00</el-radio>
                                <el-radio label="3">09:30:00</el-radio>
                                <el-radio label="4" style="margin-top:30px;">10:15:00</el-radio>
                                <el-radio label="5" >11:00:00</el-radio>
                                <el-radio label="6">11:45:00</el-radio>
                                <el-radio label="7" style="margin-top:30px;">12:30:00</el-radio>
                                <el-radio label="8" >13:15:00</el-radio>
                                <el-radio label="9" >14:00:00</el-radio>
                                <el-radio label="10" style="margin-top:30px;">14:45:00</el-radio>
                                <el-radio label="11" >15:30:00</el-radio>
                                <el-radio label="12">16:15:00</el-radio>
                                <el-radio label="13" style="margin-top:30px;">17:00:00</el-radio>
                                <el-radio label="14">17:45:00</el-radio>
                                <el-radio label="15">18:30:00</el-radio>
                                <el-radio label="16" style="margin-top:30px;">19:15:00</el-radio>
                                <el-radio label="17" >20:00:00</el-radio>
                                <el-radio label="18">20:45:00</el-radio>
                                <el-radio label="19" style="margin-top:30px;">21:30:00</el-radio>
                                <el-radio label="20">22:15:00</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="demo-drawer__footer" style="margin-left:20px;margin-top:60px;">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="addWork()">
                    确定
                </el-button>
            </div>
        </el-drawer>







    </div>
</template>

<script>
    export default {
        components: {},
        props: {},
        data() {
            return {
                addForm: {
                    shij: "",
                    id: "甲"
                },
                list:[],
                total_data:0, // 总条数
                page_size:20,
                current_page:1,
                select_id:'',
                adv_position_id:0,
                where:{
                    yuym:'',
                    dingdzt:'',
                    times:[],
                },
                zongje:0,
                dingds:0,
                changeShow:false, // 显示调整输入框
                change_info:{
                    yuym:'',
                    dingd_id:0
                },
                dingd_id:0,

                innerDrawer: false,
            };
        },
        watch: {},
        computed: {},
        methods: {
            // 添加单日排班
            addWork() {
                console.log(this.addForm)
                if(this.addForm.shij ==''){
                    this.$message.error('请选择要调整的时间');
                }
                this.$post(this.$api.Paiqgltz,this.addForm).then(res=>{
                    if(res.code == 200){
                        this.get_adv_list();
                        this.innerDrawer = false;
                        return this.$message.success("调整成功");
                    }else{
                        this.innerDrawer = false;
                        return this.$message.error("调整失败");
                    }

                });
            },
            handleClose() {
                this.innerDrawer = false;
            },
            // 排期调整
            paiqtz:function(id){
                this.addForm.id =id;
                this.innerDrawer = true;
            },
            change_user_money:function(id){
                this.dingd_id = id;
                this.changeShow = true;
            },
            change_start:function(){
                this.change_info.dingd_id = this.dingd_id;
                this.$post(this.$api.Paiqglhex,this.change_info).then(res=>{
                    if(res.code == 200){
                        this.changeShow = false;
                        this.$message.success('修改成功');
                        this.get_adv_list();
                    }else{
                        this.$message.error(res.msg);
                    }
                });
            },
            handleSelectionChange:function(e){
                let ids = [];
                e.forEach(v => {
                    ids.push(v.id);
                });
                this.select_id = ids.join(',');
            },
            get_adv_list:function(){
                let where = {};
                where.page = this.current_page;
                where.params = this.where;
                this.$get(this.$api.getPaiqglList,where).then(res=>{
                    this.page_size = res.data.data.per_page;
                    this.total_data = res.data.data.total;
                    this.current_page = res.data.data.current_page;
                    this.list = res.data.data.data;
                    this.zongje = res.data.zongje;
                    this.dingds = res.data.dingds;
                })

            },
            exports:function(){
                if(this.where.times[0]){
                    this.where.times[0] = this.where.times[0].toGMTString();
                    this.where.times[1] = this.where.times[1].toGMTString();
                }
                window.open(`https://apiuuxt.jizhikaifa.com/api/excel/orderdaoc?xiansx=${this.where.F_TI_DINGDZT}&timeone=${this.where.times[0]}&timetwo=${this.where.times[1]}`, '_self');
            },

            current_change:function(e){
                this.current_page = e;
                this.get_adv_list();
            },
        },
        created() {
            this.get_adv_list();
        },
        mounted() {}
    };
</script>
<style lang="scss" scoped>
    .table_dl_dd_all{
        height: 50px;
        overflow: hidden;
    }
    .sum_footer{
        display:flex;
        display:-webkit-flex;
        line-height:50px;
        color:#606266;
    }
    .sum_footer_unit{
        flex-grow:1;
        -webkit-flex-grow:1;
        text-indent:10px;
        font-size:14px;
        font-weight:bold;
    }
    .sum_footer_unit.center{
        text-align:center;
    }
    .sum_footer.xiaoji{
        border-bottom:1px solid #EBEEF5;
    }

    .admin_main_block_left div {
        float: left;
        margin-right: 2px;
    }

    .el-range-editor--small .el-range-input {
        font-size: 13px;
        width: 120px;
    }








    .el-table__fixed-right {
        height: 100% !important;
    }

    .calender-class {
        width: 100%;
        height: 100%;
    }

    .is-selected {
        color: #1989fa;
    }

    .el-calendar__body {
        height: 85vh;
    }

    .el-calendar-table {
        height: 100%;
    }

    .el-calendar-day {
        height: 100% !important;
    }

    .day-content-class {
        height: 100px;
        display: flex;
        flex-direction: column;
    }

    .header-class {
        flex: 1;
        display: flex;
        height: 28px;
        flex-direction: row;
        justify-content: space-between;
    }

    .day-class {
        flex: 4;
    }

    .handle-class {
        flex: 1;
    }

    .paiban-class {
        flex: 4;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-end;
        overflow: hidden;
    }

    .paiban-icon-class {
        font-size: 22px;
        margin: 8px 0 10px 0;
    }

    .paiban-name-class {
        padding-top: 10px;
    }

    .each-paiban-class {
        text-align: center;
        max-width: 50px;
        margin: 5px 5px 0 5px;
        border-radius: 5px;
        padding: 0 0 5px 0;
        flex: 1;
    }

    .zao-work-class {
        background-color: #d9ffd9;
        color: #11be11;
    }

    .wan-work-class {
        background-color: #fff0bd;
        color: #fccb2c;
    }

    .ye-work-class {
        background-color: #ddeffb;
        color: #2dabff;
    }

    .no-work-class {
        text-align: center;
        color: #cacaca;
    }

    .icon-class {
        font-size: 20px;
        margin-bottom: 20px;
    }

    /* 侧边弹窗 */
    .add-btn-class {
        margin: 10px;
        float: right;
    }

    .change-date-drawer-class .el-calendar__body {
        height: 45%;
    }

    .change-date-drawer-class .day-content-class {
        height: 30px
    }

    .disabled-date-class {
        color: #ccc;
        pointer-events: none;
    }








    * {
        box-sizing: border-box;
        user-select: none;
    }
    .CheckBox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin: 50px auto;
        margin-bottom: 20px;
    }
    .CheckItem {
        display: flex;
        margin: 0px 30px 30px 0px;
        align-items: center;
    }
    .select {
        width: 20px;
        height: 20px;
        border-radius: 2px;
        border: 1px solid #ccc;
        display: flex;
        justify-content: center;
        cursor: pointer;
        margin-right: 10px;
        align-items: center;
    }
    .selectActv::before {
        display: block;
        content: "";
        width: 5px;
        height: 12px;
        border-bottom: 2px solid #409eff;
        border-right: 2px solid #409eff;
        transform: rotate(45deg);
    }
    .selectAll{
        display: flex;
    }
    .content {
        width: 400px;
        margin:  auto 20px;
    }



</style>
